import React from 'react';
import AppRouter from './routes/Router';


const App: React.FC = () => {
  return (
    <div className="App">
      <AppRouter />  {/* Use the router for navigation */}
    </div>
  );
};

export default App;
